export const TT_EVENT_ASSIGN = 'ttEventAssign';
export const TT_EVENT_ASSIGN_END = 'ttEventAssignEnd';
export const TT_EVENT_ASSIGN_START = 'ttEventAssignStart';
export const TT_EVENT_RECEIVE_CLIENT_LIST = 'ttEventReceiveClientList';
